import { fetcherWithToken } from '@/shared/api/fetcher';
import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';

async function changeCurrency(url, { arg }: { arg: string }) {
  const params = new URLSearchParams({ currency: arg });
  return fetcherWithToken(`${url}?${params}`, {
    method: 'GET',
  });
}
export const useCurrency = () => {
  const { data, isLoading, mutate, error } = useSWR(
    '/getConvertedBalance',
    fetcherWithToken
  );

  const { trigger } = useSWRMutation('/convertBalance', changeCurrency);

  return { data, isLoading, error, trigger, mutate };
};
